/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, January 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './SwitchMode.module.css';
import PopupHeader from '../../../../components/PopupHeader';
import Button from '../../../../components/Button';
import modeEnums from '../../../../enums/modeEnums';

const MODES = [
  {
    name: 'Default',
    key: modeEnums.DEFAULT,
  },
  {
    name: 'Voucher',
    key: modeEnums.VOUCHER,
  },
  {
    name: 'Table Delivery',
    key: modeEnums.TABLE_DELIVERY,
  },
  {
    name: 'GPS Location Delivery',
    key: modeEnums.GPS_LOCATION,
  },
  {
    name: 'Cubby Manager',
    key: modeEnums.CUBBY_MANAGER,
  },
  {
    name: 'Order Status Manager',
    key: modeEnums.ORDER_STATUS_MANAGER,
  },
];


const SwitchMode = props => {
  const { onClose, currentMode, onChangeMode } = props;

  return (
    <div className={classes.container}>
      <PopupHeader
        title='Select a Mode'
        onClose={onClose}
        containerStyle={classes.headerContainerStyle}
        titleStyle={classes.titleStyle}
      />
      <div className={classes.bodyWrapper}>
        {MODES.map(mode =>
          <Button
            key={mode.key}
            className={classes.card}
            disabled={currentMode === mode.key}
            onClick={() => onChangeMode(mode.key)}
          >
            {mode.name}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SwitchMode;

SwitchMode.propTypes = {
  onClose: PropTypes.func.isRequired,
  onChangeMode: PropTypes.func,
  currentMode: PropTypes.string,
};

SwitchMode.defaultProps = {
  onClose: () => { },
  onChangeMode: () => { },
  currentMode: '',
};
